const BASE_URL = 'ai-service/api/selection-list-items'

const selectionListItemsRequests = {
  getSelectionListItemsRequest: ({ selectionListId }) => ({
    url: `${BASE_URL}/${selectionListId}`,
    method: 'get',
  }),
}

export default selectionListItemsRequests
